import { ApiBind, Common } from './common.model';

export class TopicsURL extends Common {

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'platform_name' })
  platformName: string;

  @ApiBind({ column: 'is_registered' })
  isRegistered: boolean;

  @ApiBind({ column: 'iframe_url' })
  iframeURL: string;

  @ApiBind({ column: 'expiry' })
  expiry: number;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;

}
